// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabPane_QBipP {
  background: white;
}

.tabs_wfHah {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-orient : horizontal;
  -webkit-box-direction : normal;
      -ms-flex-direction : row;
          flex-direction : row;
  -webkit-box-pack : start;
      -ms-flex-pack : start;
          justify-content : flex-start;
  -webkit-box-align : center;
      -ms-flex-align : center;
          align-items : center;
  background : #F2F4F8;
}

.tabLine_ICvGY {
  height:4px;
  opacity: 0.14;
  background-color: #00BED7;
}

.tabContent__Hga0 {
  background : #ffffff;
  margin: 48px 54px;
}

.tab_uE4qi {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  text-align: center;
  border:1px solid transparent;
  color : #666666;
  padding: 12px 50px;
  background-color: transparent;
  border:none;
  border-bottom : 4px solid transparent;
  margin-bottom: -4px;
  margin-left: 20px;
  font-size : 14px

}

.tab_uE4qi[data-active=true] {
  border-color:#00BED7;
  color:#00BED7;
}

.tab_uE4qi:focus {
  outline : none;
  color : #00BED7;
}


.tabPane_QBipP.tabPane-small_Eapy1 .tab_uE4qi {
  font-size : 11px;
  padding: 6px 16px;
  margin-left: 16px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/TabPane.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,+BAAoB;EAApB,8BAAoB;MAApB,wBAAoB;UAApB,oBAAoB;EACpB,wBAA4B;MAA5B,qBAA4B;UAA5B,4BAA4B;EAC5B,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB;;AAEF;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".tabPane {\n  background: white;\n}\n\n.tabs {\n  display : flex;\n  flex-direction : row;\n  justify-content : flex-start;\n  align-items : center;\n  background : #F2F4F8;\n}\n\n.tabLine {\n  height:4px;\n  opacity: 0.14;\n  background-color: #00BED7;\n}\n\n.tabContent {\n  background : #ffffff;\n  margin: 48px 54px;\n}\n\n.tab {\n  box-sizing: border-box;\n  text-align: center;\n  border:1px solid transparent;\n  color : #666666;\n  padding: 12px 50px;\n  background-color: transparent;\n  border:none;\n  border-bottom : 4px solid transparent;\n  margin-bottom: -4px;\n  margin-left: 20px;\n  font-size : 14px\n\n}\n\n.tab[data-active=true] {\n  border-color:#00BED7;\n  color:#00BED7;\n}\n\n.tab:focus {\n  outline : none;\n  color : #00BED7;\n}\n\n\n.tabPane.tabPane-small .tab {\n  font-size : 11px;\n  padding: 6px 16px;\n  margin-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabPane": `tabPane_QBipP`,
	"tabs": `tabs_wfHah`,
	"tabLine": `tabLine_ICvGY`,
	"tabContent": `tabContent__Hga0`,
	"tab": `tab_uE4qi`,
	"tabPane-small": `tabPane-small_Eapy1`
};
export default ___CSS_LOADER_EXPORT___;
